module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_bookmarks":"EditBookmarks","new_folder":"New Folder","delete?":"Are you sure to remove {name} from you bookmarks?"},"ja":{"edit_bookmarks":"ブックマークを編集","new_folder":"新規フォルダー","delete?":"{name}を削除しますか？"}}')
  delete Component.options._Ctor
}
